import { Add, AddShoppingCart, Remove } from '@mui/icons-material'
import { Box, Button, ButtonGroup, IconButton, Typography } from '@mui/material'

import type React from 'react'

type Props = {
  quantity: number
  minimumQuantity: number
  addToCartDisabled: boolean
  onDecrease: (e: React.MouseEvent) => void
  onIncrease: (e: React.MouseEvent) => void
  onAddToCart: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export const PopularItemActions: React.FC<Props> = ({
  quantity,
  minimumQuantity,
  addToCartDisabled,
  onDecrease,
  onIncrease,
  onAddToCart,
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
    <ButtonGroup
      variant="outlined"
      size="small"
      sx={{
        flex: 1,
        '& .MuiButton-root': {
          borderRadius: 0,
          flex: 1,
          minWidth: 0,
          px: 0,
        },
        '& .MuiButton-root:first-of-type': {
          borderTopLeftRadius: 8,
          borderBottomLeftRadius: 8,
        },
        '& .MuiButton-root:last-of-type': {
          borderTopRightRadius: 8,
          borderBottomRightRadius: 8,
        },
      }}>
      <Button
        data-cy="item-decrease"
        onClick={onDecrease}
        disabled={quantity <= 0 || quantity <= minimumQuantity}>
        <Remove fontSize="small" />
      </Button>
      <Button disabled={quantity <= 0}>
        <Typography variant="subtitle3">{quantity}</Typography>
      </Button>
      <Button data-cy="item-increase" onClick={onIncrease}>
        <Add fontSize="small" />
      </Button>
    </ButtonGroup>
    <IconButton
      data-cy="AddShoppingCartIcon"
      onClick={onAddToCart}
      disabled={addToCartDisabled}
      color="primary"
      size="small">
      <AddShoppingCart />
    </IconButton>
  </Box>
)
